export type DailyCashFlowDataPoint = {
  x: string; // ISO date string
  y: number;
};

export type CashFlowData = {
  title: string;
  xAxisName: string;
  yAxisName: string;
  current: DailyCashFlowDataPoint[];
  forecasted: DailyCashFlowDataPoint[];
  historical_forecast: DailyCashFlowDataPoint[];
};

export enum ForecastTypes {
  CASHFLOW_DAILY = "daily_cf",
  CASHFLOW_MONTHLY = "monthly_cf",
  CREDIT_DAILY = "daily_credit",
  EXPENSE_DAILY = "daily_expense",
  CATEGORY = "category",
  DAILY_BALANCE = "daily_balance",
  WEEKLY_BALANCE = "weekly_balance",
  MONTHLY_BALANCE = "monthly_balance",

  CASHFLOW_DAILY_V2 = "daily_cf_v2",
  // CASHFLOW_MONTHLY_V2 = "monthly_cf_v2",
  CREDIT_DAILY_V2 = "daily_credit_v2",
  EXPENSE_DAILY_V2 = "daily_expense_v2",
  CATEGORY_V2 = "category_v2",

  DAILY_BALANCE_V2 = "daily_balance_v2",
  WEEKLY_BALANCE_V2 = "weekly_balance_v2",
  // MONTHLY_BALANCE_V2 = "monthly_balance_v2",
  REGENERATE_CHARTS = "regenerate_charts",
}

export enum CategoryType {
  Deposits = "deposits",
  Wire_Transfers = "wire_transfers",
  Recurring_Subscriptions = "recurring_subscriptions",
  Vendor_And_ServicePayments = "vendor_and_service_payments",
  Other_DebitCard_Purchases = "other_debit_card_purchases",
  Payroll_And_Benefits = "payroll_and_benefits",
  Tax_Payments = "tax_payments",
  Claims_And_Insurance = "claims_and_insurance",
  Checks = "checks",
  Miscellaneous = "miscellaneous",
  OtherCorporate_Transactions = "other_corporate_transactions",
  General_Purchases = "general_purchases",
  Withdrawals = "withdrawals",
}

export type CashFlowResponse = {
  _id: string;
  app_key: string;
  application_id: string;
  type: ForecastTypes;
  subtype?: CategoryType;
  data: CashFlowData[];
};
